<template>
  <div>
    <stripe-checkout v-if="show" ref="checkoutRef" :pk="pk" :sessionId="sessionId" ></stripe-checkout>
  </div>
</template>

<script>
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import { SERVICE_DIRECT_MESSAGE, SERVICE_IDENTIY } from "@/properties/micro-service";
import { paymentOtherStatus, paymentPaid } from "@/common/analytics-service";
import { mapActions } from "vuex";
import { modelHttpMixin } from "@/mixin/model-http-mixin";

export default {
  name: "MessagePayment",
  mixins: [modelHttpMixin],
  components: { StripeCheckout },
  data() {
    return {
      //Strip
      pk: "",
      sessionId: "",
      show: false,
    }
  },
  methods: {
    ...mapActions(['setPayInfluencer']),
    pay(influencerId, customerId, chatMessageId, messageType, mode = 'Offline') {

      let URL = `${SERVICE_IDENTIY}/api/v1/influencers/${influencerId}`;
      this.getData(URL, (inf) => {
        let influencer = inf;
        this.setPayInfluencer(influencer);
        //Make Offline payment
        URL = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${customerId}/${chatMessageId}/purchase?mode=${mode}`;
        this.postData(URL, {}, (stripeCheckoutData) => {
          let otherData = (stripeCheckoutData && stripeCheckoutData.othersData) || {};
          let status = stripeCheckoutData ? stripeCheckoutData.status : null;
          this.pk = otherData.pk || '';
          this.sessionId = (stripeCheckoutData && stripeCheckoutData.req && stripeCheckoutData.req.id) || 
                          (stripeCheckoutData && stripeCheckoutData.res && stripeCheckoutData.res.id) || '';

          if (status === 'Success') {
            paymentPaid(this, messageType, influencer);
            this.$emit('paymentSuccess');
          } else if (status === 'InProgress') {
            this.show = true;
            setTimeout(() => {
              this.$nextTick(() => {
                if (this.$refs.checkoutRef) {
                  this.$refs.checkoutRef.redirectToCheckout();
                }
              });
            }, 300);
          } else {
            paymentOtherStatus(this, status, messageType, influencer);
            this.$emit('paymentFailed', status);
          }
        }, () => {
          URL = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${customerId}/${chatMessageId}/purchase?mode=Online`;
          this.postData(URL, {}, (stripeCheckoutData) => {
            let otherData = (stripeCheckoutData && stripeCheckoutData.othersData) || {};
            let status = stripeCheckoutData ? stripeCheckoutData.status : null;
            this.pk = otherData.pk || '';
            this.sessionId = (stripeCheckoutData && stripeCheckoutData.req && stripeCheckoutData.req.id) || 
                            (stripeCheckoutData && stripeCheckoutData.res && stripeCheckoutData.res.id) || '';
            if (status === 'Success') {
              paymentPaid(this, messageType, influencer);
              this.$emit('paymentSuccess');
            } else if (status === 'InProgress') {
              if (otherData.offlineCheckoutError) {
                this.$emit('paymentFailed', otherData.offlineCheckoutError.trim());
              }
              this.show = true;
              setTimeout(() => {
                this.$nextTick(() => {
                  if (this.$refs.checkoutRef) {
                    this.$refs.checkoutRef.redirectToCheckout();
                  }
                });
              }, 2000);
            } else {
              paymentOtherStatus(this, status, messageType, influencer);
              this.$emit('paymentFailed', status);
              this.show = true;
              setTimeout(() => {
                this.$nextTick(() => {
                  if (this.$refs.checkoutRef) {
                    this.$refs.checkoutRef.redirectToCheckout();
                  }
                });
              }, 2000);
            }
          },
          () => {
            paymentOtherStatus(this, 'payment failed', messageType, influencer);
            this.$emit('paymentFailed', "No valid cards found. You're being redirected to Stripe for another attempt. Please wait.");
            this.show = true;
            setTimeout(() => {
              this.$nextTick(() => {
                this.$refs.checkoutRef.redirectToCheckout();
              });
            }, 2000);
          });
        });
      });
    },
  }
}
</script>
